module.exports = __webpack_public_path__ + "static/img/图层 48.10c85aa6.png";